import { NgModule } from '@angular/core';
import { SepareurPipeService } from './PipeSeparateurMillier.pipe';
import { DatePipeService } from './PipeDate.pipe';
import { RubriquePipeService } from './PipeRub';

@NgModule({
  declarations: [SepareurPipeService,DatePipeService,RubriquePipeService],

  exports:[SepareurPipeService,DatePipeService,RubriquePipeService],
 
    })
    export class myPipeModule {
     
    }